export default {
    namespaced: true,
    composite_alarm_rule: {
        title: "Regla de alarma compuesta",
        is_active: "Activa",
        name: "Nombre",
        description: "Descripción",
        type_alarm: "Tipo de alarma",
        alarm_level: "Nivel de alarma",
        day_scope: "Día de operación",
        evaluation_mode: "Modo de evaluación",
        start_time: "Hora de inicio",
        end_time: "Hora de fin",
        created_at: "Fecha de creación",
        updated_at: "Fecha de actualización",
        deleted: "Regla eliminada correctamente",
        delete_error: "No se pudo eliminar la regla",
        save: "Guardar",
        created: "Regla creada correctamente",
        updated: "Regla actualizada correctamente",
        save_error: "No se pudo guardar la regla",
        load_error: "No se pudo cargar la regla",
        select_type: "Selecciona un tipo",
        select_level: "Selecciona un nivel"
    },
    general: {
        title: "Información general",
        active_rule: "Regla activa",
        rule_name: "Nombre de la regla",
        tenant: "Tenant",
        panel: "Panel",
        all_panels: "Todos los paneles del tenant",
        description: "Descripción"
    },
    programming: {
        title: "Programación",
        evaluation_mode: "Modo de evaluación",
        select_mode: "Selecciona un modo",
        mode_immediate: "Ventana",
        mode_delayed: "Después",
        activation_time: "Tiempo de activación",
        seconds: "Segundos",
        day_operation: "Día de operación",
        all_days: "Todos los días",
        business_days: "Días hábiles",
        business_days_and_saturdays: "Días hábiles y sábados",
        non_business_days_and_holidays: "Días no hábiles y festivos",
        applies_schedule: "Aplica horario",
    },
    activation_condition: {
        add_condition: "Agregar condición",
        title: "Condición de activación",
        empty: "Aún no has agregado condiciones.",
        condition: "Condición",
        remove: "Quitar",
        types: "Tipos",
        types_count: "{count} tipo(s)",
        device_type: "Tipo de dispositivo",
        details: "Detalles",
        alarm_type: "Tipo de alarma",
        acronym: "Sigla",
        ocurrencies: "Ocurrencias",
        devices: "Dispositivos",
        granular_condition: "Condición granular",
        general_condition: "Condición general",
        granular: "Granular",
        general: "General",
        device: "Dispositivo",
        device_tag: "Etiqueta del dispositivo",
        device_tag_placeholder: "Se resuelve al elegir el dispositivo",
        without_tag: "sin etiqueta",
        cancel: "Cancelar",
        add: "Agregar",
        needs_panel: "Selecciona un panel en la regla para elegir áreas y dispositivos.",
        area: "Área",
        zone: "Zona",
        area_without_zones: "Esta área no tiene zonas",
        base_alarms: "Alarmas base",
        alarm_type_hint_granular: "Alarmas según la etiqueta del dispositivo",
        alarm_type_hint_general: "Cualquier tipo de alarma",
        occurrences_hint: "Aplica a todos los tipos de esta condición",
        select_area: "Selecciona un área",
        select_zone: "Selecciona una zona",
        select_device: "Selecciona un dispositivo",
        select_alarm_type: "Selecciona un tipo de alarma",
        device_types: {
            area_zone: "Área - Zona",
            zone24h: "Zona 24h",
            door: "Puerta",
            output: "Salida"
        },
    }
};